import { useTranslation } from 'react-i18next';

export function SettingsPage() {
  const { t } = useTranslation();

  return (
    <div className='bg-white rounded-lg shadow-lg p-8'>
      <h2 className='text-2xl font-bold text-brand-gray mb-2'>{t('settings.title')}</h2>
      <p className='text-gray-600'>{t('settings.placeholder')}</p>
    </div>
  );
}
